import { IInventoryCounter } from './IInventoryCounter';
import { IInventoryDetailUniqueItem } from './IInventoryDetailUniqueItem';
import { IInventoryItem } from './IInventoryItem';

export interface IMobileInventoryCountDetail {
  inventoryCountDetailId: string;
  inventoryCountId: string;
  item: IInventoryItem;
  recommendedInventoryLevel: number;
  recommendedInventoryLevelModifiedBy: string;
  recommendedInventoryLevelModifiedDate: Date;
  countNotes: string;
  inventoryCountDetailUniqueItems: IInventoryDetailUniqueItem[];
  initialCount: number;
  initialCountModifiedBy: string;
  initialCountModifiedDate: Date;
  finalCount: number;
  broken: number;
  brokenModifiedBy: string;
  brokenModifiedDate: Date;
  over: number;
  short: number;
  pulled: number;
  pulledModifiedBy: string;
  pulledModifiedDate: Date;
  returned: number;
  returnedModifiedBy: string;
  returnedModifiedDate: Date;
  ordered: number;
  orderedModifiedBy: string;
  orderedModifiedDate: Date;
  received: number;
  receivedModifiedBy: string;
  receivedModifiedDate: Date;
  tetheringNeeded: number;
  tetheringNeededModifiedBy: string;
  tetheringNeededModifiedDate: Date;
  tetheringOrdered: number;
  tetheringOrderedModifiedBy: string;
  tetheringOrderedModifiedDate: Date;
  tetheringReceived: number;
  tetheringReceivedModifiedBy: string;
  tetheringReceivedModifiedDate: Date;
  adjustedRecommendedInventoryLevel: number;
  adjustedRecommendedInventoryLevelModifiedBy: string;
  adjustedRecommendedInventoryLevelModifiedDate: Date;
  CountAdjusted: number;
  CountAdjustedModifiedBy: string;
  countAdjustedModifiedDate: Date;
  adjustedRequest: number;
  sortOrder: number;
  modifiedBy: string;
  modifiedDate: Date;
  isActive: boolean;
  billable: boolean;
  inventoryCounters: IInventoryCounter[];
}
